export default function bytes(val = 0, decimals = 1, kib = false) {
	if (val === 0) return ' 0 Bytes'
	if (isNaN(parseFloat(val)) && !isFinite(val)) return 'Not a number'
	const k = kib ? 1024 : 1000
	const sizes = kib ? ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB'] : ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB']
	const i = Math.floor(Math.log(val) / Math.log(k))

	return parseFloat((val / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
}
